require.context('./', true, /.{1,}\.(svg|jpg|png)/);
